import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

function formatNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function counterAction(el, value, suffix, scrollTrigger) {
    gsap.from(value, {
        //scrollTrigger: scrollTrigger,  // use the scrollTrigger passed as a parameter
        scrollTrigger: {
            trigger: scrollTrigger,  // Target elements with the 'triger-select' class
            //markers: true,              // Enable markers for debugging
        },
        duration: 3,
        ease: 'circ.out',
        val: 0,
        roundProps: 'val',

        onUpdate: function() {
            el.innerText = formatNumber(value.val) + suffix;
        }
    });
}

function initCounter(el, scrollTriggerSelector) {
    const rawValue = el.dataset.value;
    let numericValue;
    let suffix = '';

    // Check if the raw value contains a '+' symbol
    if (rawValue.endsWith('+')) {
        numericValue = parseInt(rawValue.slice(0, -1)); // Parse number without the '+'
        suffix = '+'; // Store the '+' as a suffix
    } else {
        numericValue = parseInt(rawValue); // Parse as a regular number
    }

    let value = { val: numericValue }; // Initialize the GSAP animatable value
    counterAction(el, value, suffix, scrollTriggerSelector);
}


/**
 * @function counterAnimation
 * Initialize the counter animation for all elements with the class `counterClass`
 * @param {Object} scrollTrigger - The ScrollTrigger object to use for the animation
 * @param {String} counterClass - The CSS class selector for the counter elements
 * 
 * @example
 * counterAnimation('.card-subscribers-wrapper','.counter-target');     
 * 
 * <div class="counter-target" data-value="1000000"></div>
 */
export function counterAnimation(scrollTriggerSelector, counterClass) {
    const elements = document.querySelectorAll(counterClass);
    elements.forEach(el => initCounter(el, scrollTriggerSelector));
}
